import * as yup from "yup";

import { validate } from "@";

export const schema = yup
  .object({
    name: validate("req"),
    messageType: validate("req"),
    messageContent: validate("req"),
    affiliateUrlPrefix: yup
      .string()
      .nullable()
      .matches(
        /^$|^[A-Za-z]{1,5}$/,
        " حروف إنجليزية ، لا توجد أرقام أو حروف خاصة",
      ),
  })
  .required();

export const defaultValues = {
  id: null,
  name: "",
  customerType: null,
  project: {
    projectType: "",
    projectId: null,
  },
  messageType: null,
  amountFrom: null,
  amountTo: null,
  orderCountFrom: null,
  orderCountTo: null,
  joiningPeriod: null,
  frequency: null,
  messageTime: "",
  messageDate: "",
  messageContent: "",
  affiliateUrlPrefix: null,
};
